// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1935":"4ca41ded","5331":"3e25f3d1"}[chunkId] + ".chunk.css";
};